<script setup>
import { ref } from 'vue';
defineProps(['about_nac'])
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();

const loadMoreText = ref('false')
const loadMoreText2 = ref('false')

const loadMore = () => {
    return loadMoreText.value = !loadMoreText.value
}
const loadMore2 = () => {
    return loadMoreText2.value = !loadMoreText2.value
}
</script>
<template>
  <section class="text-gray-600 body-font md:flex hidden">
    <div class="container 2xl:px-24 xl:px-0 xl:pt-4 pt-0 mx-auto">
      <h2 class="text-black font-medium title-font xl:text-5xl lg:text-4xl text-2xl wow animate__animated animate__fadeInLeft">{{ locale === 'BN' ? about_nac?.bn_title : about_nac?.title }}</h2>
    <div class="flex flex-wrap xl:pt-8 pt-4">
    <div class="lg:w-1/2 pr-5 wow animate__animated animate__fadeInLeft">
        <div class="leading-relaxed text-black sm:text-[18px] text-[16px] text-justify">
            <p v-html="locale === 'BN' ? about_nac?.bn_col_one : about_nac?.col_one"></p>

      </div>
    </div>

    <div class="lg:w-1/2 lg:pl-5 wow animate__animated animate__fadeInRight">
      <div class="leading-relaxed text-gray-900 sm:text-[18px] text-[16px] text-justify">
        <p v-html="locale === 'BN' ? about_nac?.bn_col_two : about_nac?.col_two"></p>

  </div>
</div>
  </div>
</div>
</section>

  <section class="text-gray-600 body-font md:hidden flex">
    <div class="container 2xl:px-24 xl:px-0 xl:pt-4 pt-0 mx-auto">
      <h2 class="text-black font-medium title-font xl:text-5xl lg:text-4xl text-2xl wow animate__animated animate__fadeInLeft">{{locale === 'BN' ? about_nac?.bn_title : about_nac?.title}}</h2>
    <div class="flex flex-wrap xl:pt-8 pt-4">
    <div class="lg:w-1/2 pr-5 wow animate__animated animate__fadeInLeft">

      <div v-show="loadMoreText" class="leading-relaxed text-black sm:text-[18px] text-[16px] text-justify">
              <p v-html="locale === 'BN' ? about_nac?.bn_col_one.slice(0, 250) : about_nac?.col_one.slice(0, 250)"></p>
      </div>

      <div v-show="!loadMoreText" class="leading-relaxed text-black sm:text-[18px] text-[16px] text-justify" v-html="locale === 'BN' ? about_nac?.bn_col_one : about_nac?.col_one"></div>

      <span @click="loadMore" class="sm:text-base text-sm text-[#3dcae0] font-bold font-roboto cursor-pointer"> {{ loadMoreText ? $t('partner.read_more') : $t('partner.read_less') }}
        <i class="fa-solid fa-angles-right mt-1"></i></span>
    </div>

    <div class="lg:w-1/2 lg:pl-5 wow animate__animated animate__fadeInRight">

    <div v-show="loadMoreText2" class="leading-relaxed text-black sm:text-[18px] text-[16px] text-justify">
              <p v-html="locale === 'BN' ? about_nac?.bn_col_two.slice(0, 250) : about_nac?.col_two.slice(0, 250)"></p>
      </div>

      <div v-show="!loadMoreText2" class="leading-relaxed text-black sm:text-[18px] text-[16px] text-justify" v-html="locale === 'BN' ? about_nac?.col_two : about_nac?.col_two"></div>

      <span @click="loadMore2" class="sm:text-base text-sm text-[#3dcae0] font-bold font-roboto cursor-pointer"> {{ loadMoreText2 ? $t('partner.read_more') : $t('partner.read_less') }}
        <i class="fa-solid fa-angles-right mt-1"></i></span>


</div>
  </div>
</div>
</section>


</template>
<style scoped>
</style>
